export { get3dsToken } from './use3dsToken';

